export type MonitoringOptions = {
  app: "shop" | "dashboard" | "admin";
  /** Boşsa izleme kapalı (lokal, DSN girilmemiş ortam). */
  dsn: string | undefined;
  environment: string | undefined;
  release: string | undefined;
};

export type ErrorContext = { componentStack?: string | null; digest?: string };

let sentry: Promise<typeof import("./sentry") | undefined> | undefined;

/**
 * Yalnız hata izleme: performans izleme, replay ve oturum takibi yok; çerez /
 * depolama kullanılmaz. Bu yüzden shop'ta çerez onayından bağımsız açılır.
 *
 * Sentry (~30 KB gz) ayrı chunk: ilk yüklemeye girmez, DSN yoksa hiç indirilmez.
 * Chunk gelmeden atılan yakalanmamış hatalar kaçar; captureError çağrıları bekler.
 */
export function initMonitoring(options: MonitoringOptions): void {
  if (sentry || typeof window === "undefined" || !options.dsn?.trim()) return;
  sentry = import("./sentry")
    .then((module) => {
      module.startSentry(options);
      return module;
    })
    .catch(() => undefined);
}

/** Error boundary'lerin yakaladığı hatalar global handler'a düşmez; buradan gönderilir. */
export function captureError(error: unknown, context: ErrorContext = {}): void {
  void sentry?.then((module) => module?.capture(error, context));
}
